import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgrammeService } from 'src/app/services/programme.service';
import { Programme } from 'src/app/models/programme';
import { ProgrammeCourse } from 'src/app/models/programmeCourse';

@Component({
  selector: 'app-stream-programme',
  templateUrl: './stream-programme.component.html',
  styleUrls: ['./stream-programme.component.scss']
})
export class StreamProgrammeComponent implements OnInit {
  public myProgrammes: any;
  public programmesLoaded:boolean=false;
  public newProgrammeName:string='';
  public newProgrammeError:string='';
  public newProgramme:Programme=new Programme();
  public newProgrammeCourse:ProgrammeCourse=new ProgrammeCourse();

  constructor(
    public dialogRef: MatDialogRef<StreamProgrammeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _prog: ProgrammeService
  ) { }

  ngOnInit() {
    this.getProgrammes();
  }

  getProgrammes(){
    this._prog.getMyProgrammesLight().subscribe(res=>{
      this.myProgrammes = res;
      this.programmesLoaded=true;
    })
  }

  createProgrammeAndAdd(){
    if(!this.newProgramme.name) return this.newProgrammeError='Please enter a Programme name to continue.';
    this.newProgrammeError='';
    this.newProgramme.type='Personal';
    this._prog.createProgramme(this.newProgramme).subscribe(
      res=>{
        this.newProgramme=new Programme(res);
        this.assignStreamToProgramme(this.newProgramme.id);
        // this.dialogRef.close(true);
      }
    );
  }

  assignStreamToProgramme(progId:number){
    this.data.stream.active_courses.forEach(course => {
      this.newProgrammeCourse.programme_id=progId;
      this.newProgrammeCourse.course_id=course.course_id;
      this.newProgrammeCourse.course=null;
      this._prog.addCourse(this.newProgrammeCourse).subscribe();
    });
    this.dialogRef.close(true);
  };

  cancel(){
    this.newProgrammeError='';
    this.newProgramme.name='';
    this.dialogRef.close(false);
  }

}
